/**
 * Code with secret component
 * Handles displaying and toggling secret keys in code blocks
 */

import {trans} from "../i18n/i18n";

document.addEventListener('DOMContentLoaded', () => {
    const secretKeyPattern = /\$secretKey\s*=\s*["']([^"']+)["']/;
    const maskText = '**********';

    // Process all code blocks with secrets
    document.querySelectorAll('.js-code-with-secret').forEach(container => {
        const codeElement = container.querySelector('code');
        if (!codeElement) return;

        // Allow time for syntax highlighting to finish
        setTimeout(() => {
            const codeText = codeElement.textContent;
            const secretKeyMatch = codeText.match(secretKeyPattern);

            // If no secret key pattern found, return
            if (!secretKeyMatch || !secretKeyMatch[1]) return;
            const secretKey = secretKeyMatch[1];

            // Get all text nodes within the code element
            const walker = document.createTreeWalker(codeElement, NodeFilter.SHOW_TEXT, null);

            // Find the node containing the actual secret key
            while (walker.nextNode()) {
                const textNode = walker.currentNode;
                if (textNode.textContent.includes(secretKey)) {
                    // Get the text content and position of the secret
                    const originalText = textNode.textContent;
                    const secretPosition = originalText.indexOf(secretKey);

                    // Split the text: before secret, secret, after secret
                    const beforeSecret = originalText.substring(0, secretPosition);
                    const afterSecret = originalText.substring(secretPosition + secretKey.length);

                    // Update the original text node to only contain text before the secret
                    textNode.textContent = beforeSecret;

                    // Create the clickable mask element
                    const maskSpan = document.createElement('span');
                    maskSpan.className = 'api-secret-mask';
                    maskSpan.title = trans('Click to reveal secret key');
                    maskSpan.innerText = maskText;
                    maskSpan.dataset.revealed = 'false';

                    // Add the mask after the text node
                    textNode.parentNode.insertBefore(maskSpan, textNode.nextSibling);

                    // Add text after the secret as a new text node
                    if (afterSecret) {
                        const afterTextNode = document.createTextNode(afterSecret);
                        textNode.parentNode.insertBefore(afterTextNode, maskSpan.nextSibling);
                    }

                    // Toggle between masked and revealed state on click
                    maskSpan.addEventListener('click', () => {
                        const isRevealed = maskSpan.dataset.revealed === 'true';
                        maskSpan.innerText = isRevealed ? maskText : secretKey;
                        maskSpan.classList.toggle('api-secret-mask', isRevealed);
                        maskSpan.dataset.revealed = isRevealed ? 'false' : 'true';
                    });

                    break; // Stop after finding the first occurrence
                }
            }
        }, 300);
    });
});
